import React from 'react';
import { AutoComplete } from 'wix-style-react';
import { classes as inputWithOptions } from '../BlackInputWithOptions.st.css';
import { classes } from './BlackAutocomplete.st.css';

const BlackAutoComplete = (props: any) => {
  return (
    <div className={inputWithOptions.container}>
      <AutoComplete {...props} className={classes.root} />
    </div>
  );
};

export default BlackAutoComplete;
